const ACCESS_SALT = 'tgweb_access_gate_v1';
const ACCESS_PASSWORD_HASH = '9717af969339f1684e2db3608884a85b01755be29bd6a4e3dbf0e0513d2ba260';
const ACCESS_TOKEN_KEY = 'tgweb_access_token_hash';
const ACCESS_TOKEN_VALUE = ACCESS_PASSWORD_HASH;

initAccessGate();

function initAccessGate() {
  if (localStorage.getItem(ACCESS_TOKEN_KEY) === ACCESS_TOKEN_VALUE) {
    loadApp();
    return;
  }

  renderAccessScreen();
}

function renderAccessScreen() {
  const style = document.createElement('style');
  style.textContent = `
    .accessGateOverlay {
      position: fixed;
      inset: 0;
      z-index: 2147483647;
      display: grid;
      place-items: center;
      padding: 1rem;
      background: #111827;
      color: #f9fafb;
      font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif;
    }

    .accessGate {
      width: min(90vw, 22rem);
      padding: 1.25rem;
      border-radius: 0.75rem;
      background: rgba(17, 24, 39, 0.92);
      border: 1px solid rgba(255, 255, 255, 0.12);
      box-shadow: 0 0.75rem 2rem rgba(0, 0, 0, 0.45);
    }

    .accessGateTitle {
      margin: 0 0 0.75rem;
      font-size: 1rem;
      font-weight: 600;
    }

    .accessGateInput {
      width: 100%;
      box-sizing: border-box;
      padding: 0.625rem 0.75rem;
      border-radius: 0.5rem;
      border: 1px solid rgba(255, 255, 255, 0.2);
      background: rgba(31, 41, 55, 0.9);
      color: #f9fafb;
      outline: none;
    }

    .accessGateButton {
      margin-top: 0.75rem;
      width: 100%;
      padding: 0.625rem 0.75rem;
      border-radius: 0.5rem;
      border: none;
      cursor: pointer;
      font-weight: 600;
      background: #2563eb;
      color: #fff;
    }

    .accessGateButton[disabled] {
      opacity: 0.6;
      cursor: wait;
    }

    .accessGateError {
      margin-top: 0.5rem;
      min-height: 1.25rem;
      color: #fca5a5;
      font-size: 0.875rem;
    }
  `;

  const overlay = document.createElement('div');
  overlay.className = 'accessGateOverlay';

  const wrapper = document.createElement('div');
  wrapper.className = 'accessGate';
  wrapper.innerHTML = `
    <h1 class="accessGateTitle">请输入访问密码</h1>
    <input class="accessGateInput" id="accessPassword" type="password" autocomplete="off" placeholder="Password" />
    <button class="accessGateButton" id="accessSubmit" type="button">进入</button>
    <div class="accessGateError" id="accessError"></div>
  `;
  overlay.appendChild(wrapper);

  document.head.appendChild(style);
  document.body.appendChild(overlay);

  const input = document.getElementById('accessPassword') as HTMLInputElement;
  const button = document.getElementById('accessSubmit') as HTMLButtonElement;
  const error = document.getElementById('accessError') as HTMLDivElement;

  const cleanup = () => {
    button.removeEventListener('click', submit);
    input.removeEventListener('keydown', handleKeyDown);
    overlay.remove();
    style.remove();
  };

  const submit = async () => {
    if (button.disabled) {
      return;
    }

    button.disabled = true;
    error.textContent = '';

    const hash = await sha256Hex(`${input.value}::${ACCESS_SALT}`);
    if (hash !== ACCESS_PASSWORD_HASH) {
      input.value = '';
      error.textContent = '密码错误';
      button.disabled = false;
      input.focus();
      return;
    }

    localStorage.setItem(ACCESS_TOKEN_KEY, ACCESS_TOKEN_VALUE);
    cleanup();
    loadApp();
  };

  const handleKeyDown = (event: KeyboardEvent) => {
    if (event.key === 'Enter') {
      void submit();
    }
  };

  button.addEventListener('click', () => {
    void submit();
  });
  input.addEventListener('keydown', handleKeyDown);

  input.focus();
}

function loadApp() {
  import('./bootstrap').then(({ startApp }) => {
    startApp();
  });
}

async function sha256Hex(value: string) {
  const encoded = new TextEncoder().encode(value);
  const digest = await crypto.subtle.digest('SHA-256', encoded);
  const bytes = new Uint8Array(digest);

  return Array.from(bytes)
    .map((byte) => byte.toString(16).padStart(2, '0'))
    .join('');
}
